import { render, staticRenderFns } from "./ProductTraceability.vue?vue&type=template&id=41fee71c&scoped=true"
import script from "./ProductTraceability.vue?vue&type=script&lang=js"
export * from "./ProductTraceability.vue?vue&type=script&lang=js"
import style0 from "./ProductTraceability.vue?vue&type=style&index=0&id=41fee71c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fee71c",
  null
  
)

export default component.exports